import React from 'react';
import { Badge } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';

export const getApplicationColumns = (handleViewApp) => [
    {
        accessorKey: 'index',
        header: '#',
        cell: (info) => (
            <span className="opacity-50 text-white">
                {info.row.index + 1}
            </span>
        ),
        enableSorting: false,
    },
    {
        accessorKey: 'month',
        header: 'Month',
        cell: (info) => (
            <span className="text-white opacity-75">
                {info.getValue()}
            </span>
        ),
    },
    {
        accessorKey: 'candidateName',
        header: 'Candidate Name',
        cell: (info) => (
            <span className="fw-bold text-danger">
                {info.getValue()}
            </span>
        ),
    },
    {
        accessorKey: 'projectName',
        header: 'Project Name',
        cell: (info) => (
            <span className="text-info fw-semibold">
                {info.getValue()}
            </span>
        ),
    },
    {
        accessorKey: 'roleName',
        header: 'Role Name',
        cell: (info) => (
            <span className="text-white">
                {info.getValue()}
            </span>
        ),
    },
    {
        accessorKey: 'auditionType',
        header: 'Audition Type',
        cell: (info) => (
            <Badge
                bg="info"
                className="text-uppercase"
                style={{ fontSize: '10px' }}
            >
                {info.getValue()}
            </Badge>
        ),
    },
    {
        accessorKey: 'verifyStatus',
        header: 'Verify Status',
        cell: (info) => (
            <span className="text-uppercase text-white">
                {info.getValue()}
            </span>
        ),
    },
    {
        accessorKey: 'status',
        header: 'Status',
        cell: (info) => (
            <Badge
                bg={
                    String(info.getValue()).toLowerCase() === 'selected'
                        ? 'success'
                        : String(info.getValue()).toLowerCase() === 'rejected'
                        ? 'danger'
                        : 'warning'
                }
            >
                {info.getValue()}
            </Badge>
        ),
    },
    {
        accessorKey: 'date',
        header: 'Applied Date',
        cell: (info) => (
            <span className="text-white opacity-75">
                {info.getValue()}
            </span>
        ),
    },
    {
        id: 'actions',
        header: () => (
            <div style={{ textAlign: "center", width: "100%" }}>
                ACTION
            </div>
        ),
        enableSorting: false,
        cell: (info) => {
            const appId = info.row.original.id;
            return (
                <div className="d-flex justify-content-center align-items-center w-100">
                    <button
                        type="button"
                        className="view-btn-action"
                        onClick={() => handleViewApp(appId)}
                        title="View Application"
                    >
                        <FaEye size={14} color="#ffffff" />
                    </button>
                </div>
            );
        },
    }
];
